export default function validarNumeroCartao(numero: string) {
  const numeroLimpo = numero.replace(/\s+/g, '');
  const ehAmex = /^3[47]/.test(numeroLimpo) && numeroLimpo.length === 15;
  const ehPadrao =
    /^4|^5[1-5]|^2[2-7]/.test(numeroLimpo) && numeroLimpo.length === 16;

  if (!ehAmex && !ehPadrao) {
    return false;
  }

  let soma = 0;
  let deveDobrar = false;

  for (let i = numeroLimpo.length - 1; i >= 0; i--) {
    let digito = parseInt(numeroLimpo.charAt(i), 10);

    if (deveDobrar) {
      digito *= 2;
      if (digito > 9) digito -= 9;
    }

    soma += digito;
    deveDobrar = !deveDobrar;
  }

  return soma % 10 === 0;
}
